import axios from 'axios'
import Swiper, { Navigation, Pagination, Thumbs, Zoom } from 'swiper'

Swiper.use([Navigation, Pagination, Thumbs, Zoom])

const ENDPOINT = '/functions/carousel_async.php'

const carousels = [].concat(window.motostorm.asyncCarousels)

function populateCarousel(carousel, slidesHTML) {
	const sliderNodeId = `j-carousel-${carousel.id}`
	const sliderNode = document.getElementById(sliderNodeId)

	if (sliderNode) {
		const slidesWrapper = sliderNode.getElementsByClassName('swiper-wrapper')[0]
		sliderNode.getElementsByClassName('c-section-intro__title')[0].innerHTML =
			carousel.title
		sliderNode.getElementsByClassName('c-section-intro__eyelet')[0].innerHTML =
			carousel.eyelet

		slidesWrapper.innerHTML = slidesHTML
	}
}

function handleError(carousel) {
	const errorMessageNode = document.createElement('div')
	errorMessageNode.className = 'c-carousel__error'
	let string = ''
	switch (window.motostorm.lang) {
		case 'it':
		case 'en':
		case 'de':
		case 'ja':
		case 'es':
		case 'fr':
		default:
			string = 'Something went wrong. Please try again later.'
			break
	}
	errorMessageNode.innerHTML = string
	populateCarousel(carousel, errorMessageNode.outerHTML)
}

function initCarousel(carousel) {
	const sliderNodeId = `j-carousel-${carousel.id}`

	return new Swiper(`#${sliderNodeId} .j-swiper`, {
		pagination: {
			el: `#${sliderNodeId} .swiper-pagination`,
			clickable: true,
			//type: 'fraction',
		},
		navigation: {
			nextEl: `#${sliderNodeId} .swiper-button-next`,
			prevEl: `#${sliderNodeId} .swiper-button-prev`,
		},
		watchOverflow: true,
		zoom: true,
		slidesPerView: 2, // cols
		slidesPerGroup: 2,
		slidesPerColumn: 2, // rows
		slidesPerColumnFill: 'row', // note: we need it to use slidesPerColumn
		breakpoints: {
			768: {
				slidesPerView: 3, // cols
				slidesPerGroup: 3,
				slidesPerColumn: 1, // rows
			},
			1024: {
				slidesPerView: 4, // cols
				slidesPerGroup: 4,
				slidesPerColumn: 1, // rows
			},
		},
	})
}

const promises = carousels.map(
	(carousel) =>
		new Promise((resolve, reject) => {
			return axios
				.get(ENDPOINT, {
					params: {
						CarouselId: carousel.id,
						lang: window.motostorm.lang,
						IdProdotto: window.motostorm.product.productId,
					},
				})
				.then((response) => {
					populateCarousel(carousel, response.data)
					resolve(initCarousel(carousel))
				})
				.catch((error) => {
					handleError(carousel)
					reject(error)
				})
		})
)

Promise.allSettled(promises)